
const resourcePath = Array.prototype.slice.call(document.querySelectorAll("link")).map(node=>node.href).filter(href=>href.indexOf("releasedAssets")>0)[0];
const releasedAssetsPath = resourcePath && (`${resourcePath.split("releasedAssets")[0]}releasedAssets/`);
__webpack_public_path__ = releasedAssetsPath;